/**
 * Does the signed-in person hold a workbench-wide permission (outside any
 * project: connections, run credentials)? Presentation only — the server
 * checks the same permission. Inside a project use `useProject().can`.
 */

import { useCurrentUser } from "@/features/auth/hooks";
import { holds } from "@/features/auth/permissions";

export function useHolds(permission: string): boolean {
  return holds(useCurrentUser().data?.permissions ?? [], permission);
}

/** Shown where a project role hides or disables an action. */
export const ROLE_CANT_CHANGE = "Your role in this project can't change this.";
